import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Hourglass } from "react-loader-spinner";
import {
  getCardIconType,
  getCardsIcon,
  getCardTitle,
} from "../trainer-member-map/tmeMocksData";
import CommonTable from "../../common-components/common-tables/CommonTable";
import {
  CalendarIcon,
  CallIcon,
  CheckIcon,
  EmailIcon,
  PersonIcon,
  PTIcon,
  ReloadIcon,
  XCircleIcon,
} from "../../../images/icons/icons";
import { fetchApiDataDup } from "../../../redux/reducers/commonApiSlice";
import { fetchExpiredMembersData } from "../../../redux/prospect-reducers/prospectSlice";
import {
  convertStraight,
  convertTimeHHMMSS,
  formatDateTime,
} from "../../common-data/Converts";
import CalendarLoader from "../../common-components/CalendarLoader";
import { fetchTrainerPTRenewalsData } from "../../../redux/plans-reducers/plansSlice";

const TMEAnalysisDetailed = ({ userInfoData, rowData, setModValues }) => {
  const dispatch = useDispatch();
  const { dataDup, loadingDup, errorDup } = useSelector(
    (state) => state.common
  );
  const { expiredMembers, expiredMembersLoading, expiredMembersError } =
    useSelector((state) => state.prospects);
  const {
    trainerPTRenewals,
    trainerPTRenewalsLoading,
    trainerPTRenewalsError,
  } = useSelector((state) => state.plans);

  const iniDatas = {
    pagination: [],
    tbData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [lostMembersData, setLostMembersData] = useState(iniDatas);
  const [ptRenewalsData, setPTRenewalsData] = useState(iniDatas);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    limit: pageLimit,
    page: isPage + 1,
    gym_id: rowData?.gym_id || "",
    trainer_id: rowData?.trainer_id || "",
    is_tme_analysis: 1,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [selectedTab, setSelectedTab] = useState(0);

  const {
    current_trainer_avg_rating,
    total_expired_members,
    total_active_members,
  } = rowData || {};
  const rowDataObject = {
    total_members:
      Number(total_active_members || 0) + Number(total_expired_members || 0),
    total_active_members,
    total_expired_members,
    current_trainer_avg_rating,
  };

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
    setFilters(iniFilters);
  };

  function getApiData(filters) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: "/trainer/trainer_report_members_details",
        payload: {
          filters: {
            ...filters,
            user_type: "active",
          },
        },
        token: userInfoData?.token,
      })
    );
  }

  function getExpiredMembersData(filters) {
    dispatch(
      fetchExpiredMembersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getPTRenewalsData(filters) {
    dispatch(
      fetchTrainerPTRenewalsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (selectedTab === 0 && filters) {
      getApiData(filters);
    } else if (selectedTab === 1 && filters) {
      getExpiredMembersData(filters);
    } else if (selectedTab === 2 && filters) {
      getPTRenewalsData(filters);
    }
  }, [filters, selectedTab]);

  useEffect(() => {
    if (!loadingDup && !errorDup && dataDup?.status && dataDup?.data) {
      setAllDatas((prevs) => ({
        ...prevs,
        tbData: dataDup.data,
        pagination: dataDup?.pagination || [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [dataDup, loadingDup, errorDup]);

  useEffect(() => {
    if (
      !expiredMembersLoading &&
      !expiredMembersError &&
      expiredMembers?.status &&
      expiredMembers?.data
    ) {
      setLostMembersData((prevs) => ({
        ...prevs,
        tbData: expiredMembers.data,
        pagination: expiredMembers?.pagination || [],
      }));
    } else {
      setLostMembersData(iniDatas);
    }
  }, [expiredMembers, expiredMembersLoading, expiredMembersError]);

  useEffect(() => {
    if (
      !trainerPTRenewalsLoading &&
      !trainerPTRenewalsError &&
      trainerPTRenewals?.status &&
      trainerPTRenewals?.data
    ) {
      setPTRenewalsData((prevs) => ({
        ...prevs,
        tbData: trainerPTRenewals.data,
        pagination: trainerPTRenewals?.pagination || [],
      }));
    } else {
      setPTRenewalsData(iniDatas);
    }
  }, [trainerPTRenewals, trainerPTRenewalsLoading, trainerPTRenewalsError]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: pageLimit,
      page: isPage + 1,
    }));
  }, [isPage, pageLimit]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "member info",
      formatter: (_, row) => {
        const email = row?.user_email || null;
        const isEmailLong = email?.length > 15;

        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span
                className="tb-data tb-link"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    userId: row?.user_id,
                    isModOpen2: true,
                    modName2: "member_view_details",
                    rowData2: row,
                  }))
                }
              >
                {row?.user_name || "NA"}
              </span>{" "}
            </div>

            {row?.user_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>{" "}
                <span className="tb-data">{row?.user_mobile || "NA"}</span>{" "}
              </div>
            )}

            {row?.user_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>{" "}
                <span
                  className={`tb-data lowercase ${
                    isEmailLong ? "tb-data-long" : ""
                  }`}
                >
                  {row?.user_email || "NA"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    // {
    //   dataField: "days_remaining_in_membership",
    //   text: "Remaining days",
    //   wrapHeader: true,
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data tb-badge tb-badge-stuck">
    //         {row?.days_remaining_in_membership || 0} days
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "expiring_in_days",
      text: "Remaining days",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-stuck">
            {row?.expiring_in_days?.replace(/_/g, " ") || 0}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "last checkin",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            </span>
            {row?.last_checkin && (
              <span className="tb-data">
                {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""} (
                {row?.last_checkin_days_ago?.replace(/_/g, " ") || ""})
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "total_checkin_days",
      text: "Total Checkins",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.total_checkin_days ? row.total_checkin_days : 0} days
          </span>
        );
      },
    },
    {
      dataField: "total_workout_started",
      text: "total workout",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-primary">
            {row?.total_workout_started || 0} ⏱
          </span>
        );
      },
    },
    {
      dataField: "avg_rating_by_user",
      text: "trainer rating",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-primary">
            {parseFloat(row?.avg_rating_by_user || 0).toFixed(1) || 0} ★
          </span>
        );
      },
    },
    {
      dataField: "trial_status",
      text: "PT trial",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.trial_status === "completed" ? (
              <CheckIcon color="#209216" />
            ) : row?.trial_status === "pending" ? (
              <Hourglass />
            ) : (
              <XCircleIcon color="#E41815" />
            )}
          </span>
        );
      },
    },
  ];

  const tbColumns1 = [
    {
      dataField: "user_id",
      text: "member info",
      formatter: (_, row) => {
        const email = row?.user_email || null;
        const isEmailLong = email?.length > 15;

        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span
                className="tb-data tb-link"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    userId: row?.user_id,
                    isModOpen2: true,
                    modName2: "member_view_details",
                    rowData2: row,
                  }))
                }
              >
                {row?.user_name || "NA"}
              </span>{" "}
            </div>

            {row?.user_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>{" "}
                <span className="tb-data">{row?.user_mobile || "NA"}</span>{" "}
              </div>
            )}

            {row?.user_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>{" "}
                <span
                  className={`tb-data lowercase ${
                    isEmailLong ? "tb-data-long" : ""
                  }`}
                >
                  {row?.user_email || "NA"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    // {
    //   dataField: "days_since_expired",
    //   text: "expired",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data tb-badge tb-badge-stuck">
    //         {row?.days_since_expired || 0} days ago
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "expiring_in_days",
      text: "expired",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-stuck">
            {row?.expiring_in_days?.replace(/_/g, " ") || 0}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "last checkin",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            </span>
            {row?.last_checkin && (
              <span className="tb-data">
                {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""} (
                {row?.last_checkin_days_ago?.replace(/_/g, " ") || ""})
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "total_checkin_days",
      text: "Total Checkins",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.total_checkin_days ? row.total_checkin_days : 0} days
          </span>
        );
      },
    },
    {
      dataField: "total_workout_started",
      text: "total workout",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-primary">
            {row?.total_workout_started || 0} ⏱
          </span>
        );
      },
    },
    {
      dataField: "avg_rating_by_user",
      text: "trainer rating",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-primary">
            {parseFloat(row?.avg_rating_by_user || 0).toFixed(1) || 0} ★
          </span>
        );
      },
    },
    {
      dataField: "trial_status",
      text: "PT trial",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.trial_status === "completed" ? (
              <CheckIcon color="#209216" />
            ) : row?.trial_status === "pending" ? (
              <Hourglass />
            ) : (
              <XCircleIcon color="#E41815" />
            )}
          </span>
        );
      },
    },
  ];

  const ptRenewalMembersTbColumns = [
    {
      dataField: "user_id",
      text: "member info",
      formatter: (_, row) => {
        const email = row?.member_email || null;
        const isEmailLong = email?.length > 15;

        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span
                className="tb-data tb-link"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    userId: row?.user_id,
                    isModOpen2: true,
                    modName2: "member_view_details",
                    rowData2: row,
                  }))
                }
              >
                {row?.member_name || "NA"}
              </span>{" "}
            </div>

            {row?.member_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>{" "}
                <span className="tb-data">{row?.member_mobile || "NA"}</span>{" "}
              </div>
            )}

            {row?.member_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>{" "}
                <span
                  className={`tb-data lowercase ${
                    isEmailLong ? "tb-data-long" : ""
                  }`}
                >
                  {row?.member_email || "NA"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "total_renewals",
      text: "total renewals",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-min-wid-80px">
            {row?.total_renewals || 0}
          </span>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "regular subs",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.subscription_status === "active"
                ? "tb-badge-success"
                : "not-assigned"
            }`}
          >
            {row?.subscription_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "current PT subs",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.subscription_status === "active"
                ? "tb-badge-success"
                : "not-assigned"
            }`}
          >
            {row?.subscription_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "session_status",
      text: "current session status",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-min-wid-70px ${
              row?.session_status ? "tb-badge tb-badge-success-1" : ""
            }`}
          >
            {row?.session_status || "-"}
          </span>
        );
      },
    },
    {
      dataField: "last_session",
      text: "last session",
      // wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {formatDateTime(row?.last_session || "-")}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin_days_ago",
      text: "member last checkin",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {convertStraight(row?.last_checkin || "")}{" "}
              {convertTimeHHMMSS(row?.checkin_time || "")}
            </span>
            <span className="tb-data">
              {row?.last_checkin_days_ago?.replace(/_/g, " ") || ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "current PT duration",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">
                {convertStraight(row?.start_date || "")}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">
                {convertStraight(row?.expire_date || "")}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "regular_expire_date",
      text: "regular duration",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">
                {convertStraight(row?.regular_start_date || "")}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">
                {convertStraight(row?.regular_expire_date || "")}
              </span>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="mr-kpi-grid grid-5 mt30">
        {loadingDup ? (
          <CalendarLoader daysCount={4} />
        ) : (
          rowDataObject &&
          Object.entries(rowDataObject)?.map(([key, value]) => {
            return (
              <div className="mr-kpi-card" key={key}>
                <div className="mr-kpi-head">
                  <div>
                    <p className="mr-kpi-title">{getCardTitle(key)}</p>
                    <div className="mr-kpi-value-row">
                      <div className="mr-kpi-value">{value || 0}</div>
                    </div>
                  </div>
                  <span
                    className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(
                      key
                    )}`}
                  >
                    {getCardsIcon(key)}
                  </span>
                </div>
              </div>
            );
          })
        )}

        <div className="mr-kpi-card">
          <div className="mr-kpi-head">
            <div>
              <p className="mr-kpi-title">PT renewal</p>
              <div className="mr-kpi-value-row">
                <div className="mr-kpi-value">
                  {rowData?.renewal_members || 0}
                </div>
              </div>
            </div>
            <span className={`mr-kpi-icon mr-kpi-icon--success`}>
              <PTIcon />
            </span>
          </div>
        </div>
      </div>

      {/* <div className="tme-trainer-details-container mt30">
        <h2 className="tme-trainer-details-title">Trainer Details</h2>

        <div className="tme-trainer-details-grid">
          <div className="tme-trainer-details-item">
            <p className="tme-trainer-details-label">Join Date</p>
            <p className="tme-trainer-details-value">
              {rowData?.join_date || "15/01/2023"}
            </p>
          </div>

          <div className="tme-trainer-details-item">
            <p className="tme-trainer-details-label">Status</p>
            <span className="tme-trainer-details-badge tme-trainer-details-badge--active">
              {rowData?.status || "active"}
            </span>
          </div>

          <div className="tme-trainer-details-item">
            <p className="tme-trainer-details-label">Retention Rate</p>
            <p className="tme-trainer-details-value">
              {rowData?.retention_rate || "66.7%"}
            </p>
          </div>
        </div>

        <div className="tme-trainer-details-specializations">
          <p className="tme-trainer-details-specializations-label">
            Specializations
          </p>
          <div className="tme-trainer-details-tags">
            {rowData?.specializations?.length > 0 ? (
              rowData.specializations.map((spec, index) => (
                <span key={index} className="tme-trainer-details-tag">
                  {spec}
                </span>
              ))
            ) : (
              <>
                <span className="tme-trainer-details-tag">
                  Strength Training
                </span>
                <span className="tme-trainer-details-tag">Weight Loss</span>
                <span className="tme-trainer-details-tag">Bodybuilding</span>
              </>
            )}
          </div>
        </div>
      </div> */}

      <div className="tab-transparent-container mt30">
        <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
          <TabList>
            <Tab>
              <h3 className="tm-tb-header-title">
                Active Members
                {selectedTab === 0 && (
                  <button
                    className="page-heading-reload-btn"
                    onClick={() => getApiData(filters)}
                    title="Reload"
                    type="button"
                  >
                    <ReloadIcon />
                  </button>
                )}
              </h3>
            </Tab>
            <Tab>
              <h3 className="tm-tb-header-title">
                lost Members
                {selectedTab === 1 && (
                  <button
                    className="page-heading-reload-btn"
                    onClick={() => getExpiredMembersData(filters)}
                    title="Reload"
                    type="button"
                  >
                    <ReloadIcon />
                  </button>
                )}
              </h3>
            </Tab>
            {rowData?.renewal_members !== "0" && (
              <Tab>
                <h3 className="tm-tb-header-title">
                  PT renewals
                  {selectedTab === 2 && (
                    <button
                      className="page-heading-reload-btn"
                      onClick={() => getPTRenewalsData(filters)}
                      title="Reload"
                      type="button"
                    >
                      <ReloadIcon />
                    </button>
                  )}
                </h3>
              </Tab>
            )}
          </TabList>

          <TabPanel>
            <div className="flex-col-tables-container">
              <div className="common-table-container">
                <CommonTable
                  tableData={allDatas.tbData}
                  tablePagination={allDatas.pagination}
                  tableColumns={tbColumns}
                  isPage={isPage}
                  setIsPage={setIsPage}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  isLoading={loadingDup}
                />
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            <div className="flex-col-tables-container">
              <div className="common-table-container">
                <CommonTable
                  tableData={lostMembersData.tbData}
                  tablePagination={lostMembersData.pagination}
                  tableColumns={tbColumns1}
                  isPage={isPage}
                  setIsPage={setIsPage}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  isLoading={expiredMembersLoading}
                />
              </div>
            </div>
          </TabPanel>

          {rowData?.renewal_members !== "0" && (
            <TabPanel>
              <div className="flex-col-tables-container">
                <div className="common-table-container tb-bordered">
                  <CommonTable
                    tableData={ptRenewalsData.tbData}
                    tablePagination={ptRenewalsData.pagination}
                    tableColumns={ptRenewalMembersTbColumns}
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    isLoading={trainerPTRenewalsLoading}
                  />
                </div>
              </div>
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  );
};

export default TMEAnalysisDetailed;
